import { Modal, Box, Text, Button, Flex } from '@mantine/core';

interface DeleteConfirmModalProps {
  idPrefix?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  title: string;
  description: string;
  submitLabel?: string;
  cancelLabel?: string;
  submitColor?: string;
  // Override Mantine's default Modal zIndex (200). Bump this when opening
  // the confirm from inside another portal-based modal that sits higher —
  // e.g. TransformationIssuesModal uses react-modal at zIndex: 1000/1001,
  // so the nested confirm needs to clear that.
  zIndex?: number;
}

export function DeleteConfirmModal({
  idPrefix,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  description,
  submitLabel = 'Yes',
  cancelLabel = 'No',
  submitColor = 'red',
  zIndex
}: DeleteConfirmModalProps) {
  const rootId = idPrefix || 'delete-confirm-modal';

  return (
    <Modal
      id={`${rootId}-modal`}
      opened={isOpen}
      onClose={onClose}
      radius="sm"
      withCloseButton
      title={title}
      centered
      zIndex={zIndex}
    >
      <Box id={`${rootId}-content`}>
        <Text
          id={`${rootId}-description`}
          c="gray.7"
          fz="sm"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <Flex id={`${rootId}-actions`} justify="flex-end" gap="16px" mt="24px">
          <Button
            id={`${rootId}-cancel`}
            size="xs"
            color="gray"
            onClick={() => onClose()}
            variant="outline"
          >
            {cancelLabel}
          </Button>
          <Button
            id={`${rootId}-confirm`}
            size="xs"
            color={submitColor}
            loading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {submitLabel}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
